// extracted by mini-css-extract-plugin
module.exports = {"container":"BlogLayout_container__1fiRb","title":"BlogLayout_title__3HyDU"};